import Image from 'next/image'

import { Icon } from '@/shared/ui/icon'

import cl from './header-panel.module.scss'

type HeaderPanelProps = {
	title: string
	onClose: () => void
}

export const HeaderPanel = ({ onClose, title }: HeaderPanelProps) => {
	return (
		<div className={cl['chatPanel']}>
			<figure className={cl['chatPanel__bot']}>
				<Image
					className={cl['chatPanel__botImage']}
					src="/iport_ai_avatar.png"
					width="30"
					height="30"
					alt="AI помощник"
				/>
				<div className={cl['chatPanel__decsription']}>
					<figcaption className={cl['chatPanel__botName']}>{title || `ИИ-Помощник`}</figcaption>

					<span className={cl['chatPanel__botNameOnline']}>В сети</span>
				</div>
			</figure>
			<button className={cl['chatPanel__buttonClose']} onClick={onClose}>
				<Icon name="Close" stroke="#e0e0e0" width={24} height={24} className={cl['chatPanel__buttonCloseIcon']} />
			</button>
		</div>
	)
}
